module.exports = __webpack_public_path__ + "static/img/tagheuer_logo.efdb31c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/tagheuer_logo.png
// module id = wuJ6
// module chunks = 1